import FALLBACK_TRANSLATIONS from './en.json';

export const FALLBACK_LOCALE = 'en';

export { FALLBACK_TRANSLATIONS };
